import { render, staticRenderFns } from "./news3.vue?vue&type=template&id=1a77d57b&"
import script from "./news3.vue?vue&type=script&lang=js&"
export * from "./news3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports